<mat-expansion-panel class="mb-20">
  <mat-expansion-panel-header class="accent-50" >
    <mat-panel-title>
      <p *ngIf="!tipoPregunta">{{'CERTIFICAR.ADICIONALES.PREGUNTAS.WIZARD.NEW' | translate}}</p>
      <p *ngIf="tipoPregunta > 0">{{textoPregunta}}</p>
    </mat-panel-title>
    <mat-panel-description>
      <p *ngIf="!tipoPregunta">{{'CERTIFICAR.ADICIONALES.PREGUNTAS.WIZARD.TIPOTITU' | translate}}</p>
      <p *ngIf="tipoPregunta == idAbierta">{{'CERTIFICAR.ADICIONALES.PREGUNTAS.WIZARD.TIPO.OPEN' | translate}}</p>
      <p *ngIf="tipoPregunta == idSingle">{{'CERTIFICAR.ADICIONALES.PREGUNTAS.WIZARD.TIPO.UNI' | translate}}</p>
      <p *ngIf="tipoPregunta == idMulti">{{'CERTIFICAR.ADICIONALES.PREGUNTAS.WIZARD.TIPO.MULT' | translate}}</p>
    </mat-panel-description>
  </mat-expansion-panel-header>

  <!-- <div fxLayout="row" fxLayoutAlign="start center"> -->
  <!-- <div class="contenPregunta mt-20"> -->
  <div fxLayout="row" fxLayoutAlign="space-between start" class="mt-20">

    <mat-form-field appearance="outline" fxFlex="50" >
        <mat-label>{{'CERTIFICAR.ADICIONALES.PREGUNTAS.WIZARD.FORM.TIPO' | translate}}</mat-label>
        <mat-select [(value)]="tipoPregunta" [disabled]="seleccionado" required>
            <mat-option value="{{idAbierta}}" (click)="selTipoPregunta(idAbierta)">
                {{'CERTIFICAR.ADICIONALES.PREGUNTAS.WIZARD.TIPO.OPEN' | translate}}
            </mat-option>
            <mat-option value="{{idSingle}}" (click)="selTipoPregunta(idSingle)">
                {{'CERTIFICAR.ADICIONALES.PREGUNTAS.WIZARD.TIPO.UNI' | translate}}
            </mat-option>
            <mat-option value="{{idMulti}}" (click)="selTipoPregunta(idMulti)">
                {{'CERTIFICAR.ADICIONALES.PREGUNTAS.WIZARD.TIPO.MULT' | translate}}
            </mat-option>
        </mat-select>
        <mat-icon matSuffix class="secondary-text">outlined_flag</mat-icon>
        <mat-error>option is required!</mat-error>
    </mat-form-field>

      <button mat-icon-button aria-label="borraPreg" (click)="borrarPregunta()"
      matTooltip="{{'CERTIFICAR.ADICIONALES.PREGUNTAS.WIZARD.FORM.TOOLTIP.REMOVE' | translate}}">
        <mat-icon class="s-40">delete_forever</mat-icon>
      </button>

  </div>

  <div>
    <tipoAbierta *ngIf="tipoPregunta == idAbierta"
      [textoEntrada]="textoPregunta"
      [pasoCompleto]="pasoCompleto"
      (textoPregunta)="setTextoPregunta($event)"
      (guardaPreguntaBD)="enviarPreguntaBD()">
    </tipoAbierta>

    <tipoOpciones *ngIf="tipoPregunta == idSingle"
      [tipo]="1"
      [textoEntrada]="textoPregunta"
      [idsOpcionesBD]="idsOpcionesBD"
      [pasoCompleto]="pasoCompleto"
      (textoPregunta)="setTextoPregunta($event)"
      (guardaPreguntaBD)="enviarPreguntaBD()"
      (guardaOpcionBD)="guardarOpcionRespuestaBD($event)"
      (borrarOpcionBD)="borrarOpcionBD($event)"
    ></tipoOpciones>

    <tipoOpciones *ngIf="tipoPregunta == idMulti"
      [tipo]="2"
      [textoEntrada]="textoPregunta"
      [idsOpcionesBD]="idsOpcionesBD"
      [pasoCompleto]="pasoCompleto"
      (textoPregunta)="setTextoPregunta($event)"
      (guardaPreguntaBD)="enviarPreguntaBD()"
      (guardaOpcionBD)="guardarOpcionRespuestaBD($event)"
      (borrarOpcionBD)="borrarOpcionBD($event)"
    ></tipoOpciones>
  </div>


</mat-expansion-panel>
